import React from 'react'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'

const PlantSelection = ({
  personName,
  handleChangePlantName,
  plantList,
  errors,
  theme,
}) => {
  // Map selected IDs to plant objects for Autocomplete
  const selectedPlants = React.useMemo(() => {
    return (personName || []).map(id => plantList.find(p => (p._id === id || p.id === id))).filter(Boolean)
  }, [personName, plantList])

  const handleAutocompleteChange = (event, newValue) => {
    // robustly extract ID, checking for _id or id
    const selectedIds = newValue.map(plant => plant._id || plant.id)
    handleChangePlantName({
      target: { value: selectedIds },
    })
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Autocomplete
        multiple
        id="plant-selection-autocomplete"
        options={plantList || []}
        getOptionLabel={(option) => option.plantName || ''}
        value={selectedPlants}
        onChange={handleAutocompleteChange}
        isOptionEqualToValue={(option, value) => (option._id || option.id) === (value._id || value.id)}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Choose Plants*"
            placeholder="Search Plants..."
            error={!!errors.personName}
            helperText={errors.personName}
            fullWidth
            sx={{
              '& .MuiInputBase-root': {
                minHeight: '56px', // Fix for small height
                paddingTop: '8px',
                paddingBottom: '8px'
              }
            }}
          />
        )}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              label={option.plantName}
              {...getTagProps({ index })}
              key={option._id || option.id}
              sx={{
                backgroundColor: '#f0f0f0',
                margin: '2px',
                '& .MuiChip-deleteIcon': {
                  color: '#666',
                  '&:hover': {
                    color: '#333',
                  },
                },
              }}
            />
          ))
        }
      />
    </Box>
  )
}

export default PlantSelection
